import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { LessThanAge } from "../../../Common/Helpers/PensionHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { BceAndPclsTaxYear } from "../../../Common/SIPP/DrawdownDetails/BceAndPCLSTaxYear";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { CrystallisationDetailsSection } from "../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { DIAC } from "../../../Common/SIPP/DrawdownDetails/DIAC";
import { DrawdownPriceLock } from "../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { DrawdownTypeOption } from "../../../Common/SIPP/DrawdownDetails/DrawdownType";
import {
    getSellableAssets,
    hasEnhancedPensionProtection,
    isCappedOrFlexIOrUFPLS,
    isRegualr,
    showChooseAssetstoSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { IllHealth } from "../../../Common/SIPP/DrawdownDetails/IllHealth";
import { Information } from "../../../Common/SIPP/DrawdownDetails/Information";
import { LTABreakdownDetails } from "../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { PensionOptions } from "../../../Common/SIPP/DrawdownDetails/PensionOptions";
import { PensionProtection } from "../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { PreADayPensionDetails } from "../../../Common/SIPP/DrawdownDetails/PreADayPensionDetails";
import { RegularCrystallisation } from "../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { TaxFreeLumpSumPayment } from "../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { IncomeBankDetails } from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { CalculateEstimatedPaye } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/CalculateEstimatedPaye";
import { PensionBenefitsAction } from "../../Actions/PensionBenefitsAction";
import { PensionBenefitsInstructionStore } from "../../Store/Variable";

interface IPensionBenefitsDetailsProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel;
    hasCashIsa?: boolean;
    customerId?: number;
}

interface IPensionBenefitsDetailsState {
    assets: ChooseAssetsToSellAssets[];
    isLoading: boolean;
    originType: DrawdownType;
}

export class PensionBenefitsDetails extends ProcessComponent<
    IPensionBenefitsDetailsProps,
    IPensionBenefitsDetailsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
            isLoading: false,
            originType: null,
        };
    }

    isValid() {
        if (this.props.data?.Contribution?.DrawdownModel?.PreADay) {
            this.props.showErrorMsgPopUp(["Cancel the process unless select 'No' for Pre-A-Day pension details"]);
        }
        if (!this.props.data?.Contribution?.DrawdownModel?.InstructionId) {
            this.props.showErrorMsgPopUp(["Cancel the process unless as the client does not have ill health"]);
            return false;
        }
        return super.isValid() && this.props.data?.Contribution?.DrawdownModel?.PreADay == false;
    }

    private getComponentProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(this.props.type, hierarchyId, subAccountHierarchyId, (data) => {
                this.setState({ assets: data });
            });
        });
    };

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();
        if (!this.props.data.Contribution?.AdviceGiven) {
            this.onDataChange(this.props.onChange, { AdviceGiven: true }, this.props.data, "Contribution");
        }
        if (
            !LessThanAge(55, JsonDateParser.toDate(this.props.data?.ClientDetails?.DateOfBirth)) &&
            !this.props.data?.Contribution?.DrawdownModel?.InstructionId
        ) {
            this.createAndLoadDrawdownInstruction(this.props.data);
        }
    }

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const originType =
            this.state.originType ||
            PensionBenefitsInstructionStore.getData()?.Contribution?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.Contribution?.DrawdownModel?.DrawdownType;
        const _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.Contribution.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        PensionBenefitsAction.saveInstruction(1, _data, this.props.customerId, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data) {
        return (
            LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth)) &&
            !data?.Contribution?.DrawdownModel?.InstructionId
        );
    }

    private createAndLoadDrawdownInstruction(data: PensionContributionModel) {
        this.setState({ isLoading: true });

        DrawdownCalculationAction.postDrawdown(
            this.props.data?.Contribution?.HierarchyId,
            null,
            (drawdownModel: DrawdownModel) => {
                const hierarchyId = getQueryParameters()["hierarchyid"];
                const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
                const type = Number(getQueryParameters()["type"]);

                PensionBenefitsAction.getInstruction(
                    data?.Contribution?.HierarchyId,
                    type,
                    hierarchyId,
                    subAccountHierarchyId,
                    this.props.customerId,
                    () => {
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                    }
                );
            },
            true
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.createAndLoadDrawdownInstruction(data);
                    }}
                />
            );
        }
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <h2>Pension Benefits Details</h2>
                <FinancialAdvice
                    data={data?.Contribution}
                    onChange={(changes) => this.onDataChange(onChange, changes, data, "Contribution")}
                    onRef={(ref) => this.appendChild(ref)}
                />
                {data?.Contribution?.AdviceGiven && (
                    <>
                        <PensionOptions
                            {...this.getComponentProps(data, onChange)}
                            pensionProtection={data?.Contribution?.PensionProtection}
                            clientDetail={data?.ClientDetails}
                            validateDrawdown={(d) =>
                                this.onDataChange(onChange, { DrawdownModel: d }, data, "Contribution")
                            }
                        />
                        <PreADayPensionDetails {...this.getComponentProps(data, onChange)} />
                        {data?.Contribution?.DrawdownModel?.PreADay == false && (
                            <>
                                <PensionProtection
                                    {...this.props}
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.Contribution}
                                    onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                    process={ProcessType.TakePensionBenefits}
                                />
                                <BceAndPclsTaxYear
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.TakePensionBenefits}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                />
                                {data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                    <DrawdownTypeOption
                                        isImmediateTaxFreeLumpSum={
                                            !CommonHelper.isNullOrEmpty(
                                                data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId
                                            )
                                        }
                                        originType={
                                            this.state.originType ||
                                            PensionBenefitsInstructionStore.getData()?.Contribution?.DrawdownModel
                                                ?.DrawdownType
                                        }
                                        {...this.getComponentProps(data, onChange)}
                                        pensionProtection={data?.Contribution?.PensionProtection}
                                    />
                                )}
                            </>
                        )}
                        <Information {...this.getComponentProps(data, onChange)} />
                        {data?.Contribution?.DrawdownModel?.PreADay == false && (
                            <>
                                {isRegualr(data?.Contribution?.DrawdownModel) &&
                                    data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                        <RegularCrystallisation
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.TakePensionBenefits}
                                        />
                                    )}
                                {isCappedOrFlexIOrUFPLS(data?.Contribution?.DrawdownModel) && (
                                    <CrystallisationDetailsSection
                                        isImmediateTaxFreeLumpSum={
                                            !CommonHelper.isNullOrEmpty(
                                                data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId
                                            )
                                        }
                                        cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                                        doCalculation={() => this.doCalculation()}
                                        modelData={null}
                                        processType={ProcessType.TakePensionBenefits}
                                        {...this.getComponentProps(data, onChange)}
                                        pensionProtection={data?.Contribution?.PensionProtection}
                                    />
                                )}
                                <LTABreakdownDetails
                                    doCalculation={() => this.doCalculation()}
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.TakePensionBenefits}
                                    lessThan75={ageLessThan75}
                                />
                                <TaxFreeLumpSumPayment
                                    process={ProcessType.TakePensionBenefits}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                    {...this.getComponentProps(data, onChange)}
                                    lessThan75={ageLessThan75}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                />
                                {data?.Contribution?.DrawdownModel?.DrawdownType !== DrawdownType.Regular &&
                                    data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                        <DIAC
                                            {...this.getComponentProps(data, onChange)}
                                            modelData={data?.Contribution}
                                            existingAccount={true}
                                        />
                                    )}
                                <OAC
                                    readonly={true}
                                    type={SubAccountType.Npr}
                                    onChange={(v) => {}}
                                    data={{
                                        OngoingAdviceCharge:
                                            data?.Contribution?.DrawdownModel?.DrawdownAdviserCharge
                                                ?.OngoingAdviserCharge,
                                    }}
                                    onRef={(ref) => this.appendChild(ref)}
                                />
                                <hr />
                                <DrawdownPriceLock {...this.getComponentProps(data, onChange)} />
                                {showChooseAssetstoSell(
                                    data?.Contribution?.DrawdownModel,
                                    ChooseAssetsToSellFor.Drawdown
                                ) && (
                                    <>
                                        <ChooseAssetsToSell
                                            {...this.getComponentProps(data, onChange)}
                                            tableKey={"PensionCommencementLumpSumAllocations"}
                                        />
                                        {data?.Contribution?.DrawdownModel?.IsAcrossAllAssets == false && (
                                            <ChooseAssetsToSellTable
                                                data={
                                                    data?.Contribution?.DrawdownModel
                                                        ?.PensionCommencementLumpSumAllocations || []
                                                }
                                                tableData={this.state.assets}
                                                modelData={data?.Contribution?.DrawdownModel}
                                                onRef={(ref) => this.appendChild(ref)}
                                                onChange={(v) => {
                                                    this.onDataChange(
                                                        (changes) =>
                                                            this.onDataChange(onChange, changes, data, "Contribution"),
                                                        { PensionCommencementLumpSumAllocations: v },
                                                        data.Contribution,
                                                        "DrawdownModel"
                                                    );
                                                }}
                                                processType={ProcessType.TakePensionBenefits}
                                                reason={ChooseAssetsToSellFor.Drawdown}
                                            />
                                        )}
                                    </>
                                )}

                                {data?.Contribution?.DrawdownModel?.PensionOption === PensionOption.UFPLS && (
                                    <>
                                        <CalculateEstimatedPaye />
                                        <hr />
                                        <IncomeBankDetails
                                            data={
                                                data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations ||
                                                []
                                            }
                                            onChange={(value) => {
                                                onChange(
                                                    setValueByKey(
                                                        data,
                                                        "Contribution.DrawdownModel.Income.IncomePaymentAllocations",
                                                        value
                                                    )
                                                );
                                            }}
                                            showErrorMsgPopUp={(msg, isShow) =>
                                                this.props.showErrorMsgPopUp(msg, isShow)
                                            }
                                            onRef={(ref) => this.appendChild(ref)}
                                            allBankAccounts={data?.AllBankAccounts}
                                            showPropotionOfIncome={false}
                                        />
                                    </>
                                )}
                                {/* <hr /> */}
                                {/* <SwitchInvestments {...this.getComponentProps(data, onChange)} /> */}
                            </>
                        )}
                    </>
                )}
            </PartLoading>
        );
    }
}
